import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeDomain: localStorage.getItem("domainKey") ?? "",
};

export const globalSettingsSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    updateGlobalSettingsState: (state, action) => {
      Object.assign(state, action.payload ?? {});
    },
    updateBlogSlug: (state, action) => {
      state.activeBlogPage = action.payload;
    },
    updateDomainKey: (state, action) => {
      state.activeDomain = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateGlobalSettingsState, updateBlogSlug ,updateDomainKey} =
  globalSettingsSlice.actions;

export default globalSettingsSlice.reducer;
